<template>
  <div class="Home" v-on:click="ScreenTouch">
    <div id="topword" class="smallsize">
      <Row>
        <Col span="12" style="padding-right: 20px"> <strong><u>Important Safety Information</u></strong><br>
          Radiation treatments may cause side effects that can vary depending on the part of the body being treated. The most frequent ones are typically temporary and may include, but are not limited to, irritation to the respiratory, digestive, urinary or reproductive systems, fatigue, nausea, skin irritation, and hair loss. In some patients, they can be severe. Treatment sessions may vary in complexity and time. Radiation treatment is not appropriate for all cancers.
          </Col>
        <Col span="12" style="padding-right: 20px"><strong><u>Medical Advice Disclaimer</u></strong><br>
          Varian as a medical device manufacturer cannot and does not recommend specific treatment approaches. Individual treatment results may vary. <br>Not all products or features available for sale in all markets</Col>
      </Row>


    </div>
    <Bigmenu :ShowBackBtn="false" :WhiteIcon="hamburgerWhite" v-on:cellback="MenuCellback" style="z-index: 4"></Bigmenu>

    <Mainmenu :Target="slogantarget" :WhiteText="menuWhite" v-on:cellback="NavCellback" style="z-index: 3"></Mainmenu>
    <div class="topband" style="z-index: -1"></div>
    <div class="logo"></div>
    <div class="logotext">Cancer Care</div>
    <Slogan :Target="slogantarget" :White="sloganWhite"></Slogan>
    <Bigbtn :Target="slogantarget" style="z-index: 2"></Bigbtn>
    <div class="frame" style="z-index: -7"></div>

    <Kevisual :Target="slogantarget" style="z-index: -8"></Kevisual>
    <router-view/>
  </div>
</template>
<script>


import Bigmenu from '@/components/Bigmenu.vue'
import Mainmenu from '@/components/Mainmenu.vue'
import Kevisual from '@/components/Kevisual.vue'
import Slogan from '@/components/Slogan.vue'
import Bigbtn from '@/components/Bigbtn.vue'
import countdowns from '../config/countdown'
import { mapGetters } from 'vuex'
import { pickTextColors } from '@/utils/autoContrast'

export default {
  name: 'Home',
  components: {Bigmenu, Mainmenu, Kevisual, Slogan, Bigbtn},
  data () {
    return {
      aboutmenu: true,
      Bignav: false,
      slogantarget: 0,
      countTime: 360,

      autotimer: null,
      timer: null,
      // 每個分類底圖各區域自動判斷出來的文字顏色
      tones: []
    }
  },
  mounted () {
    this.countDownfun()
    this.measureContrast()
  },
  computed: {
    ...mapGetters(['getTouchScreen', 'getTimer']),
    tone () {
      return this.tones[this.slogantarget] || {}
    },
    sloganWhite () {
      return this.tone.slogan === 'white'
    },
    hamburgerWhite () {
      return this.tone.hamburger === 'white'
    },
    menuWhite () {
      return [0, 1, 2, 3, 4].map(i => this.tone['menu' + i] === 'white')
    }
  },
  methods: {
    MenuCellback () {
      this.Bignav = false
    },
    NavCellback (t) {
      this.slogantarget = t

    },
    // 讀每張主視覺底圖，算出各區域該用黑字還是白字
    async measureContrast () {
      const layers = ['one', 'two', 'three', 'four', 'five']
      const COLW = 1920 / 5
      const regions = {
        slogan: { x: 80, y: 200, w: 600, h: 300 },
        hamburger: { x: 1830, y: 20, w: 70, h: 70 }
      }
      layers.forEach((l, i) => {
        regions['menu' + i] = { x: i * COLW, y: 760, w: COLW, h: 100 }
      })

      const tones = []
      for (const name of layers) {
        const el = this.$el.querySelector('.Kv > div.' + name)
        tones.push(el ? await pickTextColors(el, regions) : {})
      }
      this.tones = tones
    },
    countDownfun () {

      clearInterval(this.getTimer)
      this.countdown = this.countTime
      this.$store.dispatch('actionCountDownNum', setInterval(() => {
        this.countdown--
        // console.log(this.countdown)
        if (this.countdown == 0) {
          clearInterval(this.getTimer)
          if(this.$router.currentRoute.name !== 'Home'){
            this.$router.replace('/Home')
          }

          this.autoPlay()
        }

      }, 1000))

    },
    autoPlay () {

      this.autotimer = setInterval(() => {
        this.slogantarget++
        if (this.slogantarget == 5) {
          this.slogantarget = 0
        }
      }, 3000)

    },
    ScreenTouch () {

      this.countDownfun()

    }

  }
}
</script>
<style lang="scss" scoped>

  .frame {

    position: absolute;
    background-image: url("../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;

  }

  .logo {
    background-image: url("../assets/logo3.svg");
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
    margin: 40px;
    margin-top: 25px;
    margin-left: 40px;
    width: 250px;
    height: 80px;
    position: absolute;
  }

  .topband {
    position: absolute;
    top: 0;
    left: 0;
    width: 1920px;
    height: 126px;
    /* 左邊實色白、往右漸淡至全透明 */
    background-image: linear-gradient(
      to right,
      #ffffff 0%,
      #ffffff 30%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  .logotext {
    position: absolute;
    margin-top: 25px;
    margin-left: 310px;
    height: 80px;
    line-height: 80px;
    font-family: 'SH Bree Headline', 'MyCustomFont', 'Noto Sans TC';
    font-size: 2.2rem;
    color: #4d4d4d;
    text-align: left;
    white-space: nowrap;
  }

  .menu {
    position: absolute;
    width: 100vw;
    margin-top: 80vh;
    background-color: aquamarine;
  }

  .menubtn {
    width: 100%;
    height: 50px;
    background-color: #ff2e13;
  }

  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
  #topword{

    color: #666666;
    margin-top: 1005px;
    position: absolute;
  }

  .smallsize{
    margin-left: 20px;
    margin-right: 20px;
    -webkit-transform: scale(1);
    font-size: 10px;
    text-align: left;
  }
</style>
